import spanishMessages from '@blackbox-vision/ra-language-spanish';

export let esMessages = {
  ...spanishMessages,
  ra: {
    ...spanishMessages.ra,
    page: {
      ...spanishMessages.ra.page,
      loading: 'Cargando',
    },
    message: {
      ...spanishMessages.ra.message,
      loading: 'La página se está cargando, espere un momento por favor',
    },
  },
  auth: {
    forget_password: {
      success_message: 'Se ha enviado un email a tu casilla de correo',
      error_message: 'Parece que algo ha salido mal, reintente más tarde',
    },
    two_factor: {
      not_authorized: 'Esta cuenta no está habilitada para la consola.',
      invalid_code: 'El código no es válido. Verificá la app e intentá de nuevo.',
    },
  },
  resources: {
    'admin-audit': {
      name: 'Auditoría',
    },
    users: {
      name: 'Usuarios',
      import: {
        success: 'Usuarios importados exitosamente',
        alreadyInUseError:
          'Algunos de los usuarios que desea importar ya existen',
        error: 'Ha ocurrido un error durante la importación de usuarios',
      },
      fields: {
        id: 'UID',
        email: 'Email',
        country: 'País',
        password: 'Contraseña',
        phoneNumber: 'Celular',
        isAdmin: 'Administrador',
        fullName: 'Nombre Completo',
        createdAt: 'Fecha de Creación',
        updatedAt: 'Fecha de Actualización',
        identityDocument: {
          value: 'Número de Documento',
          type: 'Tipo de Documento',
        },
      },
    },
    currencies: {
      name: 'Monedas',
      fields: {
        id: 'ID',
        logo: 'Logo',
        'logo.src': 'Logo',
        name: 'Abreviatura',
        fullName: 'Nombre Completo',
        createdAt: 'Fecha de Creación',
        updatedAt: 'Fecha de Actualización',
        coingeckoId: 'ID de CoinGecko',
        pegUsd: 'Vale 1 USD',
        rail: 'Riel',
        apr: 'APR (%)',
        category: 'Categoría',
        description: 'Descripción',
      },
    },
    'jobs-config': {
      name: 'Tareas',
      fields: {
        id: 'ID',
        name: 'Nombre',
        description: 'Descripción',
        expression: 'Tiempo de Ejecucion',
        createdAt: 'Fecha de Creación',
        updatedAt: 'Fecha de Actualización',
      },
    },
    transactions: {
      name: 'Transacciones',
      fields: {
        id: 'ID',
        uid: 'Usuario',
        currency: 'Moneda',
        rail: 'Riel',
        action: 'Acción',
        status: 'Estado',
        amount: 'Monto',
        createdAt: 'Fecha de Creación',
        updatedAt: 'Fecha de Actualización',
      },
    },
    investments: {
      name: 'Inversiones',
      fields: {
        id: 'ID',
        uid: 'Usuario',
        currency: 'Moneda',
        amount: 'Monto',
        interest: 'Interés Generado',
        createdAt: 'Fecha de Creación',
        updatedAt: 'Fecha de Actualización',
      },
    },
    interests: {
      name: 'Intereses',
      fields: {
        id: 'ID',
        uid: 'Usuario',
        investmentId: 'Inversión',
        investment: 'Inversión',
        amount: 'Interés (USD)',
        currency: 'Moneda de liquidación',
        sourceCurrency: 'Moneda de origen',
        sourceAmount: 'Interés en moneda de origen',
        priceUsd: 'Precio USD aplicado (EMA 15 días)',
        createdAt: 'Fecha de Creación',
        updatedAt: 'Fecha de Actualización',
        liquidated: 'Liquidado',
      },
    },
  },
};
